import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { useParams } from 'react-router'

type MessagesWorkspacesWorkspaceCard = RestSchemas['Messages.Workspaces.WorkspaceCard']
export type MessagesWorkspacesWorkspaceCardFixed = Omit<MessagesWorkspacesWorkspaceCard, 'appTypes'> & {
  app_types: number
}

export function useCurrentWorkspace() {
  const params = useParams()
  const workspaceId = Number(params.workspaceId)
  const { getWorkspacesApiGetCurrentUserWorkspace } = useRestClient()

  const { data } = getWorkspacesApiGetCurrentUserWorkspace.useSuspenseQuery({
    path: { workspaceId },
  })

  const workspace = data as unknown as MessagesWorkspacesWorkspaceCardFixed

  if (!workspace) {
    throw new Error('Workspace not found')
  }

  return workspace
}
